var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgOfficeLogo = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "4 2 40 44",
  width: "1em",
  height: "1em",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m20.084 3.026-.224.136a8.007 8.007 0 0 0-1.009.722l.648-.456H25L26 11l-5 5-5 3.475v4.008a8 8 0 0 0 3.857 6.844l5.264 3.186L14 40h-2.145l-3.998-2.42A8 8 0 0 1 4 30.737V17.26a8 8 0 0 1 3.86-6.846l12-7.258c.074-.045.149-.089.224-.131Z",
  fill: "url(#officeLogo_svg__a)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m20.084 3.026-.224.136a8.007 8.007 0 0 0-1.009.722l.648-.456H25L26 11l-5 5-5 3.475v4.008a8 8 0 0 0 3.857 6.844l5.264 3.186L14 40h-2.145l-3.998-2.42A8 8 0 0 1 4 30.737V17.26a8 8 0 0 1 3.86-6.846l12-7.258c.074-.045.149-.089.224-.131Z",
  fill: "url(#officeLogo_svg__b)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M32 19v4.48a8 8 0 0 1-3.857 6.844l-12 7.264a8 8 0 0 1-8.008.16l11.722 7.096a8 8 0 0 0 8.286 0l12-7.264A8 8 0 0 0 44 30.736V27.5L43 26l-11-7Z",
  fill: "url(#officeLogo_svg__c)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M32 19v4.48a8 8 0 0 1-3.857 6.844l-12 7.264a8 8 0 0 1-8.008.16l11.722 7.096a8 8 0 0 0 8.286 0l12-7.264A8 8 0 0 0 44 30.736V27.5L43 26l-11-7Z",
  fill: "url(#officeLogo_svg__d)"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "m40.14 10.415-12-7.258a8 8 0 0 0-8.042-.139l-.238.144A8 8 0 0 0 16 10.008v9.483l3.86-2.334a8 8 0 0 1 8.28 0l12 7.258A8 8 0 0 1 43.997 31c.003-.088.004-.175.004-.263V17.26a8 8 0 0 0-3.86-6.845Z",
  fill: "url(#officeLogo_svg__e)"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "m40.14 10.415-12-7.258a8 8 0 0 0-8.042-.139l-.238.144A8 8 0 0 0 16 10.008v9.483l3.86-2.334a8 8 0 0 1 8.28 0l12 7.258A8 8 0 0 1 43.997 31c.003-.088.004-.175.004-.263V17.26a8 8 0 0 0-3.86-6.845Z",
  fill: "url(#officeLogo_svg__f)"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M4.004 30.998Z",
  fill: "url(#officeLogo_svg__g)"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M4.004 30.998Z",
  fill: "url(#officeLogo_svg__h)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "officeLogo_svg__a",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "rotate(110.528 5.021 11.358) scale(33.3657 58.1966)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.064,
  stopColor: "#AE7FE2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0078D4"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "officeLogo_svg__c",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "matrix(30.7198 -4.51832 2.98465 20.29248 10.43 36.351)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.134,
  stopColor: "#D59DFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5E438F"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "officeLogo_svg__e",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "matrix(-24.1583 -6.12555 10.3118 -40.66824 41.055 26.504)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.058,
  stopColor: "#50E6FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#436DCD"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "officeLogo_svg__g",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "matrix(-24.1583 -6.12555 10.3118 -40.66824 41.055 26.504)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.058,
  stopColor: "#50E6FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#436DCD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "officeLogo_svg__b",
  x1: 17.512,
  y1: 37.868,
  x2: 12.751,
  y2: 29.635,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#114A8B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0078D4",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "officeLogo_svg__d",
  x1: 40.357,
  y1: 25.377,
  x2: 35.255,
  y2: 32.692,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#493474"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8C66BA",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "officeLogo_svg__f",
  x1: 16.976,
  y1: 3.057,
  x2: 24.487,
  y2: 3.057,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#2D3F80"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#436DCD",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "officeLogo_svg__h",
  x1: 16.976,
  y1: 3.057,
  x2: 24.487,
  y2: 3.057,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#2D3F80"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#436DCD",
  stopOpacity: 0
})))));

const ForwardRef = /*#__PURE__*/forwardRef(SvgOfficeLogo);
export default ForwardRef;